module.exports = __webpack_public_path__ + "img/2-.7e28cb43.png";